import {compose} from "redux";
import React, { Component } from 'react';
import SVG from "react-inlinesvg";

import roomFeatureGuests from "../../images/room-feature-guests.svg";

import RoomTypeAvailability from "./RoomTypeAvailability";
import withLocalize from "../../withLocalize";

class RoomTypeAvailabilities extends Component {
	handleRoomTypeAvailabilityClick = (e, day) => {
		e.preventDefault();

		this.props.onRoomTypeAvailabilityClick(day);
	};

	render() {
		const { days, roomType, translatePropertyValue} = this.props;

		return (
			<div className="room-type-availabilities">
				<div className="room-type-availabilities__header-container">
					{roomType.rooms > 1 &&
					<span className="room-type-availabilities__room-type-count">{roomType.rooms} &times; </span>
					}
					<span className="room-type-availabilities__room-type-name">{translatePropertyValue(roomType.name)}</span>
					<span className="room-type-availabilities__room-type-guests">
						{[...Array(roomType.beds)].map((_, index) => (
						<SVG key={index} src={roomFeatureGuests} />
						))}
					</span>
				</div>
				<div className="room-type-availabilities__day-container">
					{[...Array(roomType.availabilities.length).keys()].map((_, day) => (
					<RoomTypeAvailability key={day} date={days[day]} value={roomType.availabilities[day]} max={roomType.rooms} onClick={e => this.handleRoomTypeAvailabilityClick(e, day)} />
					))}
				</div>
			</div>
		);
	}
}

export default compose(
	withLocalize,
)(RoomTypeAvailabilities);



// WEBPACK FOOTER //
// ./src/components/Occupancies/RoomTypeAvailabilities.jsx